(function () {
  const root = document.getElementById("orbita-pack-quiz");
  if (!root) return;

  const PILLARS = ["crossfit", "gym", "nutricion", "movilidad"];
  const PRODUCTO_LABEL = {
    crossfit: "CrossFit", gym: "Gym", nutricion: "Nutrición", movilidad: "Movilidad / Calentamiento",
  };
  const DISCOUNT_CODE = { 2: "PACK2", 3: "PACK3", 4: "PACK4" };

  const META = {};
  PILLARS.forEach(p => {
    META[p] = {
      variantId: Number(root.dataset[`variant${p[0].toUpperCase()}${p.slice(1)}`]),
      price: root.dataset[`price${p[0].toUpperCase()}${p.slice(1)}`],
    };
  });

  // Steps that belong to each pillar, in the order they should appear —
  // ids match each .oq-step[data-step] in this section, prefixed so the
  // same underlying question (e.g. "objetivo") can exist once per pillar
  // without colliding in `state`.
  const STEP_MAP = {
    crossfit: ["cf_nivel", "cf_material", "cf_gimnasticos", "cf_objetivo", "cf_dias"],
    gym: ["gy_objetivo", "gy_nivel", "gy_dias", "gy_enfoque", "gy_material", "gy_duracion"],
    nutricion: ["nu_objetivo", "nu_dias", "nu_actividad", "nu_cribado", "nu_historia", "nu_contexto"],
    movilidad: ["mo_donde", "mo_zonas", "mo_cuando", "mo_tiempo"],
  };

  const allSteps = Array.from(root.querySelectorAll(".oq-step"));
  const stepById = {};
  allSteps.forEach(s => { stepById[s.dataset.step] = s; });

  let selected = []; // pillar keys, in click order — order doesn't matter functionally
  let order = ["seleccion"];
  let current = 0;
  const state = {};
  const labels = {};

  const ringFill = document.getElementById("oq-ring-fill");
  const RING_LEN = 276.4602;
  const stepNumEl = document.getElementById("oq-step-num");
  const stepTotalEl = document.getElementById("oq-step-total");
  const nextBtn = document.getElementById("oq-next");
  const backBtn = document.getElementById("oq-back");
  const footer = root.querySelector(".oq-footer");

  // --- SELECTION STEP (toggle 2-4 pillars, live price preview) -----------
  const selectCards = root.querySelectorAll('#oq-pillar-select .oq-card');
  const priceLine = document.getElementById("oq-pack-price-preview");

  function recomputePricePreview() {
    if (selected.length < 2) {
      priceLine.textContent = "Elige al menos 2 pilares para ver tu precio.";
      return;
    }
    const total = selected.reduce((sum, p) => sum + parseFloat(META[p].price.replace(",", ".")), 0);
    const pct = selected.length === 2 ? 5 : selected.length === 3 ? 10 : 25;
    const final = total * (1 - pct / 100);
    priceLine.textContent =
      `${selected.length} pilares · ${total.toFixed(2).replace(".", ",")} € → ` +
      `${final.toFixed(2).replace(".", ",")} € (-${pct}%)`;
  }

  selectCards.forEach(card => {
    card.addEventListener("click", () => {
      const p = card.dataset.value;
      if (selected.includes(p)) {
        selected = selected.filter(x => x !== p);
        card.classList.remove("selected");
      } else {
        if (selected.length >= 4) return;
        selected.push(p);
        card.classList.add("selected");
      }
      recomputePricePreview();
      nextBtn.disabled = selected.length < 2;
    });
  });

  // --- generic field binding (same conventions as pillar-quiz.js) --------
  root.querySelectorAll(".oq-cards[data-name], .oq-pills[data-name]").forEach(group => {
    const name = group.dataset.name;
    group.querySelectorAll("button").forEach(btn => {
      btn.addEventListener("click", () => {
        group.querySelectorAll("button").forEach(b => b.classList.remove("selected"));
        btn.classList.add("selected");
        state[name] = btn.dataset.value;
        const strong = btn.querySelector("strong");
        labels[name] = strong ? strong.textContent : btn.textContent.trim();
        onFieldChange();
      });
    });
  });

  root.querySelectorAll(".oq-check-grid[data-name]").forEach(group => {
    const name = group.dataset.name;
    const inputs = group.querySelectorAll("input[type=checkbox]");
    inputs.forEach(cb => {
      cb.addEventListener("change", () => {
        if (cb.value === "ninguna" && cb.checked) {
          inputs.forEach(other => { if (other !== cb) other.checked = false; });
        } else if (cb.checked) {
          const ninguna = Array.from(inputs).find(i => i.value === "ninguna");
          if (ninguna) ninguna.checked = false;
        }
        const checked = Array.from(inputs).filter(i => i.checked);
        state[name] = checked.map(i => i.value);
        labels[name] = checked.map(i => (i.closest("label").textContent || "").trim()).join(", ");
        onFieldChange();
      });
    });
  });

  root.querySelectorAll(".oq-step [name]").forEach(el => {
    if (el.closest(".oq-check-grid")) return;
    const name = el.name;
    const sync = () => {
      state[name] = el.value;
      labels[name] = el.tagName === "SELECT" ? (el.options[el.selectedIndex]?.text || el.value) : el.value;
      onFieldChange();
    };
    el.addEventListener("input", sync);
    el.addEventListener("change", sync);
  });

  function updateReveals() {
    root.querySelectorAll("[data-reveal-when]").forEach(target => {
      const sep = target.dataset.revealWhen.indexOf(":");
      const name = target.dataset.revealWhen.slice(0, sep);
      const wanted = target.dataset.revealWhen.slice(sep + 1).split(",").map(s => s.trim());
      const val = state[name];
      const matches = Array.isArray(val) ? val.some(v => wanted.includes(v)) : wanted.includes(val);
      target.hidden = !matches;
    });
  }

  function onFieldChange() { updateReveals(); validateCurrentStep(); }

  // --- order computation ----------------------------------------------------
  function computeOrder() {
    let o = ["seleccion", "datos", "lesiones"];
    // Preserve a stable pillar order (matches the selector card order) so
    // the questionnaire always flows CrossFit -> Gym -> Nutrición -> Movilidad
    // regardless of the order the customer clicked the cards in.
    PILLARS.forEach(p => { if (selected.includes(p)) o = o.concat(STEP_MAP[p]); });
    o.push("resumen");
    return o;
  }

  // --- validation -----------------------------------------------------------
  function validateCurrentStep() {
    const stepId = order[current];
    if (stepId === "seleccion") { nextBtn.disabled = selected.length < 2; return selected.length >= 2; }
    const el = stepById[stepId];
    let ok = true;
    el.querySelectorAll("input[required], select[required], textarea[required]").forEach(f => {
      if (!f.value) ok = false;
    });
    el.querySelectorAll(".oq-cards[data-required], .oq-pills[data-required]").forEach(g => {
      if (!state[g.dataset.name]) ok = false;
    });
    el.querySelectorAll(".oq-check-grid[data-required]").forEach(g => {
      if (!state[g.dataset.name] || state[g.dataset.name].length === 0) ok = false;
    });
    nextBtn.disabled = !ok;
    return ok;
  }

  function showStep(idx) {
    const stepId = order[idx];
    allSteps.forEach(s => s.classList.toggle("active", s.dataset.step === stepId));
    stepNumEl.textContent = idx + 1;
    stepTotalEl.textContent = order.length;
    const progress = (idx + 1) / order.length;
    ringFill.style.strokeDashoffset = String(RING_LEN * (1 - progress));
    backBtn.style.visibility = idx === 0 ? "hidden" : "visible";
    footer.style.display = stepId === "resumen" ? "none" : "flex";
    if (stepId === "resumen") renderResumen();
    validateCurrentStep();
  }

  nextBtn.addEventListener("click", () => {
    if (!validateCurrentStep()) return;
    if (current === 0) order = computeOrder(); // lock in the step list once selection is confirmed
    if (current < order.length - 1) { current += 1; showStep(current); }
  });
  backBtn.addEventListener("click", () => {
    if (current > 0) { current -= 1; showStep(current); }
  });

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, s => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[s]));
  }

  function renderResumen() {
    const summaryEl = document.getElementById("oq-summary");
    let rows = `<div>Pilares: <b>${selected.map(p => PRODUCTO_LABEL[p]).join(", ")}</b></div>`;
    order.forEach(stepId => {
      if (stepId === "seleccion" || stepId === "resumen") return;
      const el = stepById[stepId];
      el.querySelectorAll("[data-name]").forEach(g => {
        const name = g.dataset.name, label = g.dataset.label;
        if (!label || !labels[name]) return;
        rows += `<div>${escapeHtml(label)}: <b>${escapeHtml(labels[name])}</b></div>`;
      });
    });
    summaryEl.innerHTML = rows;

    const total = selected.reduce((sum, p) => sum + parseFloat(META[p].price.replace(",", ".")), 0);
    const pct = selected.length === 2 ? 5 : selected.length === 3 ? 10 : 25;
    const final = total * (1 - pct / 100);
    const buyBtn = document.getElementById("oq-buy-btn");
    buyBtn.textContent = `Comprar Pack — ${final.toFixed(2).replace(".", ",")} € (-${pct}%)`;
  }

  // --- build one line item's properties from the shared + pillar steps ---
  function buildPillarProperties(pillar) {
    const props = {
      "Nombre": state.nombre || "", "Email contacto": state.email || "", "Producto": PRODUCTO_LABEL[pillar],
    };
    if (pillar !== "nutricion") {
      props["Lesiones"] = (state.lesiones || []).join(", ") || "Ninguna";
    } else {
      ["edad", "sexo", "peso", "altura"].forEach(f => { props[
        { edad: "Edad", sexo: "Sexo", peso: "Peso (kg)", altura: "Altura (cm)" }[f]
      ] = state[f] || ""; });
    }
    STEP_MAP[pillar].forEach(stepId => {
      stepById[stepId].querySelectorAll("[data-name]").forEach(g => {
        const name = g.dataset.name, label = g.dataset.label;
        if (!label) return;
        const val = state[name];
        props[label] = Array.isArray(val) ? (val.join(", ") || "Ninguna") : (val || "");
      });
    });
    return props;
  }

  document.getElementById("oq-buy-btn").addEventListener("click", (e) => {
    const btn = e.currentTarget;
    if (btn.disabled) return;
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = "Redirigiendo al pago...";

    const items = selected.map(pillar => ({
      id: META[pillar].variantId, quantity: 1, properties: buildPillarProperties(pillar),
    }));
    const code = DISCOUNT_CODE[selected.length] || "PACK4";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("No se pudo añadir al carrito");
        window.location.href = `/checkout?discount=${code}`;
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = originalText;
        alert("Ha ocurrido un error al procesar tu pedido. Inténtalo de nuevo.");
      });
  });

  showStep(0);
})();